import { Button } from "components/Button";
import { Header } from "components/Header";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import { InputFormField } from "components/InputFormField";
import React from "react";
import { useHistory } from "react-router-dom";
import { useSessionsTable, EventSession } from "./useSessionsTable";
import { Container, TableSearchSessions } from "./styles";

const tableHead = [
  "Título",
  "Descrição",
  "Data/Hora",
  "Local",
  "Palestrantes",
  "",
];

export const SessionsTable: React.FC = () => {
  const { push } = useHistory();

  const handleCreateSession = () => {
    push(`/events/${eventId}/session/create`);
  };

  const handleEditSession = (session: EventSession) => {
    push(`/events/${eventId}/session/${session.sessionId}/edit`);
  };

  const {
    loading,
    error,
    properties,
    sessionRows,
    sessions,
    eventId,
    searchText,
    searchTextFormRef,
    handleSearchTextFormSubmit,
    handleExportCsv,
  } = useSessionsTable(handleEditSession);

  return (
    <Container>
      <div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "end",
            justifyContent: "space-between",
            marginBottom: "1rem",
          }}
        >
          <TableSearchSessions
            className="table-search-sessions"
            onSubmit={handleSearchTextFormSubmit}
            ref={searchTextFormRef}
            style={{ flex: 1 }}
          >
            <InputFormField
              label="Buscar sessões"
              autoFocus={true}
              name="searchText"
              marginBotton={"0"}
              backGround={"white"}
              defaultValue={searchText}
              block={true}
            />
            <Button label="Buscar" typeBtn="blue" type="submit" block={false} />
          </TableSearchSessions>

          <Button
            label="Exportar CSV"
            typeBtn="outline"
            onClick={handleExportCsv}
            block={false}
          />
          <Button
            label="Criar Sessão"
            typeBtn="blue"
            onClick={handleCreateSession}
            block={false}
          />
        </div>
      </div>

      {loading && <Loading />}

      {error && !loading && <PlaceHolderNotExists title="Erro ao carregar" />}

      {!loading && !error && (
        <>
          <TableModifiedCards properties={properties || []} />

          <TableModifiedTable
            headerColumns={tableHead}
            rows={sessionRows}
            onRowClick={(_, rowIndex) => {
              if (sessions && sessions[rowIndex]) {
                handleEditSession(sessions[rowIndex]);
              }
            }}
          />
        </>
      )}
    </Container>
  );
};
